export class BitwiseHelper {
	public static and(...params: number[]): number {
		return params.reduce((prev, current) => prev & current);
	}

	public static or(...params: number[]): number {
		return params.reduce((prev, current) => prev | current);
	}
}
